var _path, _circle, _rect, _path2, _circle2, _circle3, _rect2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerracedHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 22V30L46 34.5V39.5L44 38V71H68.5V38L71 39V34.5L35.5 15V20L38.5 22Z",
    fill: "#8D84F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 40,
    r: 4,
    fill: "#5B53B5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 50,
    width: 12,
    height: 20,
    fill: "#5B53B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1792 13L47.0445 33.5825L47 41L9.1792 20.5L9.1792 13Z",
    fill: "#D4D5FC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 40,
    r: 5,
    fill: "#D4D5FC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.6792,
    cy: 59.5,
    r: 1.5,
    fill: "#5B53B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 50,
    width: 14,
    height: 21,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 45C24.7614 45 27 42.7614 27 40C27 37.2386 24.7614 35 22 35C19.2386 35 17 37.2386 17 40C17 42.7614 19.2386 45 22 45ZM22 43C23.6569 43 25 41.6569 25 40C25 38.3431 23.6569 37 22 37C20.3431 37 19 38.3431 19 40C19 41.6569 20.3431 43 22 43Z",
    fill: "#231C70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11H15V16.164L9.1792 13V20.5L11.1792 21.5841L11.1792 70H7C6.44772 70 6 70.4477 6 71C6 71.5523 6.44772 72 7 72L73 72C73.5523 72 74 71.5523 74 71C74 70.4477 73.5523 70 73 70H69.5V39.7421L71.8208 41L71.8653 33.5825L34 13V20.5L37 22.1261V28.1226L23 20.5126V11ZM39 29.2097L47.0445 33.5825L47 41L45.1792 40.0131V70L67.5 70V38.658L64.4429 37.001L39 23.6539V29.2097ZM26.1792 69.9999H38.1792V51H26.1792V69.9999ZM40.1792 49V69.9999H43.1792V38.929L13.1792 22.6681L13.1792 69.9999H24.1792V49H40.1792ZM21 19.4255V13H17V17.2512L21 19.4255ZM13.3503 20.486L45.0231 37.1455L45.0373 34.7678L11.1792 16.3635V19.3092L13.3503 20.486ZM69.5 37.3954V37.4672L69.8408 37.6519L69.8581 34.7678L36 16.3635V19.3092L65.384 35.2362L69.5 37.3954Z",
    fill: "#231C70"
  })));
}
export default SvgTerracedHouse;